import React from 'react'
import env from './../../environments/environment'
import { toJS } from 'mobx'
import EnrollingAgentBar from './components/EnrollingAgentBar/EnrollingAgentBar.component'
import EnrollmentStageManager from './components/EnrollmentStageManager/EnrollmentStageManager.component'
import EnrollmentUpline from './components/EnrollmentUpline/EnrollmentUpline.component'
import EnrollmentStore from './shared/Enrollment.store'
import Navbar from './../../components/newhome/Navbar'
import moment from 'moment'
import { toast } from 'react-toastify'
import CryptoJS from 'crypto-js'
import AuthService from './../../shared/services/Auth.service'
import UserProfileService from './../../shared/services/UserProfile.service'
import { isWhiteLabelUpline, getWhiteLabelLogo } from './../../shared/utilities/whiteLabel.function'

import './EnrollmentPage.scss'

class EnrollmentPage extends React.Component {
  state = {
    useDemo: false,
    upline: false,
  }

  _loadDependencies(upline) {
    EnrollmentStore.isLoading = true
    EnrollmentStore.setDownline(upline)
    EnrollmentStore.setUpline(upline).then(
      async res => {
        switch (res) {
          case true:
            await Promise.all([
              EnrollmentStore.fetchCommissionLevels(),
              EnrollmentStore.fetchTerms(),
              EnrollmentStore.fetchRecruitingLeadSources(),
            ])
            this.setState({ upline: toJS(EnrollmentStore.upline) })
            break
          case 'UPLINE_CANNOT_RECRUIT':
            toast.error('The selected agent can not enroll new agents.', {
              position: toast.POSITION.TOP_RIGHT,
            })
            break
          case 'UPLINE_LOCKED_RECRUIT':
            toast.error(
              'The selected recruiter must complete their account requirements before enrolling new agents.',
              { position: toast.POSITION.TOP_RIGHT }
            )
            break
          case 'INVALID_UPLINE_USER':
            toast.error('The selected recruiter is invalid.', {
              position: toast.POSITION.TOP_RIGHT,
            })
            break
        }

        EnrollmentStore.isLoading = false
      },
      err => {
        console.log('Failed to load enrollment dependencies. ', err)
        EnrollmentStore.isLoading = false
      }
    )
  }

  _shouldActivateDemo() {
    if (['local', 'beta'].indexOf(env.env) > -1 && this.props?.location?.search) {
      let search = this.props.location.search
      return (search.charAt(0) === '?' ? search.substr(1) : search) === 'demo=1'
    }

    return false
  }

  _checkRecruiterId(u_login) {
    let search = this.props.location.search

    let urlParams = new URLSearchParams(search)
    let recruiterId = urlParams.get('recruiterId')
    if (recruiterId) {
      recruiterId = recruiterId.replace(/ /g, '+')
      const bytes = CryptoJS.AES.decrypt(recruiterId, 'usabg')
      const decryptedId = bytes.toString(CryptoJS.enc.Utf8)
      if (decryptedId) {
        EnrollmentStore.recruiterId = decryptedId
      }
      return decryptedId
    }

    return false
  }

  _checkComissionCode(u_login) {
    let search = this.props.location.search

    let urlParams = new URLSearchParams(search)
    let com_code = urlParams.get('com_code')
    if (com_code) {
      com_code = com_code.replace(/ /g, '+')
      const bytes = CryptoJS.AES.decrypt(com_code, 'usabg')
      const decryptedComCode = bytes.toString(CryptoJS.enc.Utf8)
      if (decryptedComCode) {
        EnrollmentStore.commissionCode = decryptedComCode
        EnrollmentStore.intake.commission_id = decryptedComCode
      }
      return decryptedComCode
    }

    return false
  }

  _checkUplineId(u_login) {
    let search = this.props.location.search

    let urlParams = new URLSearchParams(search)
    let uplineId = urlParams.get('uplineId')
    if (uplineId) {
      uplineId = uplineId.replace(/ /g, '+')
      const bytes = CryptoJS.AES.decrypt(uplineId, 'usabg')
      const decryptedUplineId = bytes.toString(CryptoJS.enc.Utf8)
      console.log(decryptedUplineId)
      if (decryptedUplineId) {
        EnrollmentStore.uplineId = decryptedUplineId
        EnrollmentStore.intake.upline_override = decryptedUplineId
      }
      return decryptedUplineId
    }

    return false
  }

  _checkShowAffiliate() {
    let search = this.props.location.search
    let urlParams = new URLSearchParams(search)
    if (urlParams.get('show_affiliate') === '1') {
      EnrollmentStore.showAffiliate = true
    }
  }

  _activateDemo() {
    EnrollmentStore.intake.u_fname = 'James[TEST]'
    EnrollmentStore.intake.u_lname = 'Miller[TEST]'
    EnrollmentStore.intake.u_email = 'sw+usabg.' + Math.floor(Math.random() * 9999999999) + '@stevenawaskey.com'
    EnrollmentStore.intake.u_password = 'secret'
    EnrollmentStore.intake.u_address1 = '5141 Mariner Blvd'
    EnrollmentStore.intake.u_city = 'Spring Hill'
    EnrollmentStore.intake.u_zip = '34609'
    EnrollmentStore.intake.u_phone = '8005551212'
    EnrollmentStore.intake.u_birthday = moment().subtract(30, 'years').toDate()
    EnrollmentStore.intake.u_state = 'FL'
    EnrollmentStore.intake.u_enroll_source = 'Indeed'
    EnrollmentStore.intake.u_enroll_source_detail = ''
    EnrollmentStore.intake.commission_id = '127'
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props

    if (UserProfileService.get('u_login') == params?.u_login && EnrollmentStore.isAuthenticated) {
      // If same login user is trying to open enrollment link in new tab
      AuthService.logout()
    }
    this._loadDependencies(params?.u_login)

    EnrollmentStore.reset()
    EnrollmentStore.setIp()

    this._checkRecruiterId(params?.u_login)
    this._checkComissionCode(params?.u_login)
    this._checkUplineId(params?.u_login)
    this._checkShowAffiliate()

    // If in dev env & param passed, populate demo data.
    if (this._shouldActivateDemo()) this._activateDemo()
  }

  // Read individual UI-toggle query params. Each param is its own concrete
  // switch (hide_header, hide_footer, future show_affiliate_package, etc.)
  // so callers can opt in/out of each component independently.
  _uiToggles() {
    const search = this.props?.location?.search || ''
    const p = new URLSearchParams(search)
    return {
      hideHeader: p.get('hide_header') === '1',
      hideFooter: p.get('hide_footer') === '1',
    }
  }

  render() {
    toast.configure()

    const { hideHeader, hideFooter } = this._uiToggles()
    const rootClasses = [hideHeader ? 'hide-header' : '', hideFooter ? 'hide-footer' : ''].filter(Boolean).join(' ')

    const upline = this.state.upline || EnrollmentStore.upline
    const isWhiteLabel = isWhiteLabelUpline(upline)
    const whiteLabelLogo = isWhiteLabel ? getWhiteLabelLogo(upline?.white_label_logo) : false

    return (
      <div id='EnrollmentPage' className={rootClasses}>
        <EnrollingAgentBar goTo={goTo => this.props.history.push(goTo)} />
        {!hideHeader && (
          <Navbar
            phone={EnrollmentStore.upline?.u_marketing_phone || false}
            whiteLabelLogo={whiteLabelLogo}
            hideDefaultLogo={isWhiteLabel}
            isResolvingBrand={!upline?.id}
          />
        )}
        <div className='text-center enroll-heading'>
          {isWhiteLabel ? <></> : <div>Welcome to USABG</div>}
          <h3>New Agent Enrollment</h3>
        </div>
        <div className='enroll-upline-container'>
          <EnrollmentUpline upline={this.state.upline} />
        </div>
        <div className='enroll-stages-container'>
          {this.state.upline ? (
            <EnrollmentStageManager useDemo={this.state.useDemo} upline={this.state.upline} />
          ) : (
            <></>
          )}
        </div>
      </div>
    )
  }
}

export default EnrollmentPage
